<template>
  <div>
    <validation-observer ref="observer" v-slot="{ handleSubmit }" v-if="form">
      <b-modal
        :visible="openModal"
        @change="(val) => $emit('closeModal', false)"
        size="lg"
        class="rounded-0"
        centered
        title="Hotel Excel içe aktar"
        @ok.prevent="handleSubmit(onSubmit)"
      >
        <b-card-text>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Excel Dosyası">
                <b-form-file
                  ref="excelFileInput"
                  v-model="excelFile"
                  :state="excelFile ? true : null"
                  accept=".xls,.xlsx"
                  placeholder="Excel dosyası seçiniz"
                  browse-text="Dosya Seç"
                  :disabled="show"
                />
                <small class="text-muted d-block mt-1">Yalnızca .xls ve .xlsx dosyaları desteklenir.</small>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-text>
        <template #modal-footer="{ ok }">
          <div class="w-100">
            <b-button size="lg" squared variant="primary" class="float-right" type="submit" @click="ok()" :disabled="show">
              <i class="fad fa-save" v-if="!show" />
              <b-spinner class="mr-25" small variant="light" v-else />
              {{ form.k_no == null ? 'KAYDET' : 'GÜNCELLE' }}
            </b-button>
          </div>
        </template>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import { ref, watch } from '@vue/composition-api';

export default {
  components: {},
  props: {
    openModal: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, context) {
    const expo = {};
    const toast = useToast();
    expo.show = ref(false);

    expo.form = ref({});
    expo.excelFile = ref(null);
    expo.excelFileInput = ref(null);

    const resetForm = () => {
      expo.form.value = {};
      expo.excelFile.value = null;
      if (expo.excelFileInput.value && typeof expo.excelFileInput.value.reset === 'function') {
        expo.excelFileInput.value.reset();
      }
    };

    watch(
      () => props.openModal,
      (val) => {
        if (!val) {
          resetForm();
          expo.show.value = false;
        }
      }
    );

    expo.onSubmit = () => {
      if (!expo.excelFile.value) {
        toast.error('Lütfen bir Excel dosyası seçiniz', { position: 'bottom-left' });
        return;
      }
      expo.show.value = true;

      const payload = new FormData();
      payload.append('file', expo.excelFile.value);

      store
        .dispatch('hotelExcelIceAktar', payload)
        .then((res) => {
          toast.success(`İçe aktarma tamamlandı. ${(res.data && res.data.data && res.data.data.length) || 0} satır işlendi`, {
            position: 'bottom-left',
          });
          expo.show.value = false;
          resetForm();
          context.emit('closeModal', false);
        })
        .catch((err) => {
          const message = err?.response?.data?.message || 'Excel içe aktarma sırasında hata oluştu';
          toast.error(message, { position: 'bottom-left' });
          expo.show.value = false;
        });
    };

    return { ...expo };
  },
};
</script>

<style lang="scss" scoped></style>
